import React from "react";
import WhiteLogo from "../assets/images/whitelogo.png";
import ClassPhoto from "../assets/images/hompage2.jpeg";
import "@fontsource-variable/plus-jakarta-sans";
import "../style/studentPortal.css";

// Kerangka halaman login dan halaman buat/lupa password: kartu putih
// terbelah dua — panel foto gelap di kiri, form di kanan.
const PortalAuthLayout = ({ children }) => (
  <div className="sp-auth">
    <div className="sp-auth-card">
      <div className="sp-auth-visual" style={{ backgroundImage: `url(${ClassPhoto})` }}>
        <div className="sp-auth-visual-brand">
          <img src={WhiteLogo} alt="" />
          Cutting Edge Academy
        </div>
        <div className="sp-auth-visual-caption">
          <span></span>
          <h2>Student Portal</h2>
          <p>Your class history, attendance records and assignment results in one place.</p>
        </div>
      </div>

      <div className="sp-auth-panel">
        <div className="sp-auth-wordmark">CUTTING EDGE ACADEMY</div>
        <div className="sp-auth-body">{children}</div>
        <p className="sp-auth-copy">&copy; {new Date().getFullYear()} Cutting Edge Academy</p>
      </div>
    </div>
  </div>
);

export default PortalAuthLayout;
